export default __webpack_public_path__ + "static/homeSwirl3-dba2b636b3a8fa81d75dc7c7f7fa732f.svg";